import Vue from 'vue'
import ProductDataMixin from 'js/pages/municipality-data/balance/products/_product-data.js'

import Show from '../show'
import template from './_product-card.pug'
// @vue/component
export default {
  template: template(),
  components: {Show},
  mixins: [ProductDataMixin],

  /*
  * CurretTab could be available or historical
  * In the pug show table in function of value currentTab
  */
  props: {
    id: {
      type: String,
      default: undefined
    },

    product: {
      type: Object,
      required: true
    },

    currentTab: {
      type: String,
      required: true
    }
  },

  methods: {
    click() {
      this.$emit('click')
    },

    loadImg() {
      if (this.product.product_entity_product_logo) {
        return this.product.product_entity_product_logo.url
      } else if (this.$store.getters.currentAppConfig.default_logo_url) {
        return this.$store.getters.currentAppConfig.default_logo_url
      }

      return null
    },

    filterStatusProduct(product) {
      return product.status === 'active' ?
        Vue.i18n.t('balance.products.status.active') :
        Vue.i18n.t('balance.products.status.inactive')
    },

    productHasValidity(product) {
      return product.valid_from && product.valid_to
    },

    // eslint-disable-next-line consistent-return
    getBalance(product) {
      if (product.product_entity_balance_type === 'trips') {
        return `${product.balance} ${Vue.i18n.t('balance.products.trips')}`
      }
    },

    // eslint-disable-next-line consistent-return
    getRechargeDate(product) {
      if (product.last_recharge_date != null) {
        const rechargeDate = this.formattedDate(product.last_recharge_date)

        return `${rechargeDate}`
      }
    },
    // eslint-disable-next-line consistent-return
    getOriginDestination(stopFromName, stopToName) {
      if (stopFromName != null && stopToName != null) {
        return `${stopFromName} - ${stopToName}`
      }
    },

    showProduct(id) {
      this.$router.push({name: 'wallet-products-show', params: {id}})
    },

    // eslint-disable-next-line consistent-return
    getValidFromTo(product) {
      if (product.valid_from != null && product.valid_to != null) {
        const validFrom = this.formattedDate(product.valid_from)
        const validTo = this.formattedDate(product.valid_to)

        return `${validFrom} ${Vue.i18n.t('balance.products.validTo')} ${validTo}`
      }
    },
    getBalanceStyle(balance) {
      return balance < 0 ? 'text-danger' : 'text-info'
    },

    supportTypeText(support_entity_type) {
      return Vue.i18n.t(
        `balance.products.productsData.supportEntityTypes.${support_entity_type}`
      )
    },

    getStatus(product) {
      if (product.status === 'active') {
        return ` ${Vue.i18n.t('balance.products.status.active')}`
      }

      return ` ${Vue.i18n.t('balance.products.status.inactive')}`
    },

    formattedDate(date) {
      return moment(date).tz(this.administrativeArea.time_zone).format('DD/MM/YYYY')
    },

    changeLimit(limit) {
      this.pagination.limit = limit
      this.pagination.currentPage = 1
      this.getProducts()
    },
    changePage(page) {
      this.pagination.currentPage = page
      this.getProducts()
    }
  }
}
